export default "__VITE_ASSET__D2os7q_k__"